namespace Areas.Drawing.Unclassify {

    "use strict";

    let projectId = 0;
    let runQuery: boolean = false;

    var drawingGrid: DevExpress.ui.dxDataGrid;
    const unclassifyButtonName: string = "UnclassifyButton";

    $(() => { init(); });

    function init() {
        drawingGrid = $("#UnclassifyDrawingDataGrid").dxDataGrid("instance");
    }

    export function downloadDrawingLink(cellElement: any, cellInfo: any) {
        //var buildingId = cellInfo.component.option("buildingId");
        //var content = `<a href= '/File/Get/Drawing/${cellInfo.data.drawingId}?buildingId=${buildingId}'>Download</a>`;
        var content = `<a href= '/File/Get/Drawing/${cellInfo.data.drawingId}'>Download</a>`;
        cellElement.html(content);
    }    

    export function projectSelected(e: any) {
        projectId = e.selectedRowKeys[0];
        runQuery = true;                    
        getDrawings();
    }

    function getDrawings() {
        drawingGrid.deselectAll();  
        drawingGrid.getDataSource().reload();
        Areas.disableButton(unclassifyButtonName);                
    }

    export function drawingSelected(e: any) {
        if (drawingGrid.getSelectedRowKeys().length > 0) {
            Areas.enableButton(unclassifyButtonName);
        } else {
            Areas.disableButton(unclassifyButtonName);
        }
    }

    export function unclassifyDrawings() {
        var drawingIds = drawingGrid.getSelectedRowKeys();
        sendRequest("/Drawing/Unclassify/UnclassifyDrawings", JSON.stringify(drawingIds), "POST", 
            () => { getDrawings(); } );
    }    

    export function getProjectId() {
        return projectId;
    }

    export function canExecuteQuery() {
        return runQuery;
    }
}